import styled from 'styled-components';

export const ErrorPageContainer = styled.div`
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;

  h1 {
    font-weight: 700;
    line-height: 1.2;
    font-size: 2.5rem;

    @media (min-width: 1200px) {
      font-size: 5rem;
    }
  }

  p {
    font-size: 1.75rem;

    &.lead {
      font-size: 1.25rem;
      font-weight: 300;
    }
  }
`;
